import { render, staticRenderFns } from "./KucunList.vue?vue&type=template&id=0f9b9042&scoped=true&"
import script from "./KucunList.vue?vue&type=script&lang=js&"
export * from "./KucunList.vue?vue&type=script&lang=js&"
import style0 from "./KucunList.vue?vue&type=style&index=0&id=0f9b9042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b9042",
  null
  
)

export default component.exports